import useErrorHandler from "../components/ErrorHandler";
import { useDispatch } from "react-redux";
import { fetchBranches } from "../features/branchesSlice";
import useMerchantPortalAxios from "../utils/axios";
import {useState} from "react";

/**
 * Hook with the Branch manipulation APIs
 * @returns An object containing the APIs for handling branches
 */
const useBranchAPI = () => {
  /**
   * Retrieve the error handler toast
   */
  const { ErrorHandler } = useErrorHandler();

  /**
   * Bring the dispatch function to use RTK features
   */
  const dispatch = useDispatch();


  /**
   * Merchant Portal Axios instance
   */
  const MerchantPortalClient = useMerchantPortalAxios();

  const [branchDetailsLoading, setBranchDetailsLoading] = useState(true);

  /**
   * This API updates the branch visibilty on sKash app whenever a user clicks the switch
   * @param {any} payload parameters of the function
   * @returns The new branch visibility state
   */
  const UpdateBranchVisibility = async (
    payload
  ) => {
    try {
      const res = await MerchantPortalClient.post(`/v1/Branch/UpdateBranchVisibility`, payload)
      return res.data.Payload;
    } catch (e) {
      ErrorHandler(e);
    } finally {
      dispatch(fetchBranches());
    }
  };

  /**
   * Adds a new branch to the Merchant 
   * @param {any} payload parameters of the function
   * @returns The new added branch 
   */
  const AddBranch = async (payload) => {
      const res = await MerchantPortalClient.post(`/v1/Branch/AddBranch`, payload)
      return res.data.Payload;
  };

  /**
   * Edits a branch
   * @param {any} payload parameters of the function
   * @returns The edited branch with the new data
   */
  const EditBranch = async (payload) => {
      const res = await MerchantPortalClient.post(`/v1/Branch/EditBranch`, payload);
      return res.data.Payload;

  };

  /**
   * Deletes a branch
   * @param {any} payload parameters to send
   * @returns Message that the branch was deleted
   */
  const DeleteBranch = async (payload) => {
      const res = await MerchantPortalClient.post(`/v1/Branch/DeleteBranch`, payload);
      return res.data
  };

  const [branchDetails, setBranchDetails] = useState([]);
  async function GetBranchDetails(branchID){
    await MerchantPortalClient.post(
        `/v1/Branch/GetBranchInformation`,
        {
          SessionID: sessionStorage.getItem("SessionID"),
          BranchID: branchID
        }
    ).then((res)=>{
      setBranchDetails(res.data.Payload);
      setBranchDetailsLoading(false);
    });

  }

  const [branchTills, setBranchTills] = useState([]);
  const [remainingTills, setRemainingTills] = useState([]);
  const [initialBranchTillsTable, setInitialBranchTillsTable] = useState([]);
  const [initialRemainingBranchTills, setInitialRemainingBranchTills] = useState([]);
  async function GetBranchTills(branchID){
    await MerchantPortalClient.post(
        `/v1/Branch/GetBranchTills`,
        {
          SessionID: sessionStorage.getItem("SessionID"),
          BranchID: branchID
        }
    ).then((res)=>{
      setBranchTills(res.data.Payload.portalBranchTills);
      setRemainingTills(res.data.Payload.remainingBranchTills);
      setInitialBranchTillsTable(res.data.Payload.portalBranchTills);
      setInitialRemainingBranchTills(res.data.Payload.remainingBranchTills);
    });
  }

  async function GetBranchTills2(branchID){
    const res = await MerchantPortalClient.post(
        `/v1/Branch/GetBranchTills`,
        {
          SessionID: sessionStorage.getItem("SessionID"),
          BranchID: branchID
        }
    )
    return res.data.Payload;
  }

  const GenerateBranchTillOTP = async (MerchantUserOnBoardID) => {
    const res = await MerchantPortalClient.post(
        `/v1/Branch/ResetBranchTillOTP`,
        {
          SessionID: sessionStorage.getItem("SessionID"),
          MerchantUserOnBoardID: MerchantUserOnBoardID,
        }
    );
    return res.data;
  };

  const AssignTill = async (MerchantUserOnBoardID, TillBranchID) => {
    await MerchantPortalClient.post(`/v1/Branch/AssignTill`, {
      SessionID: sessionStorage.getItem("SessionID"),
      MerchantUserOnBoardID: MerchantUserOnBoardID,
      TillBranchID: TillBranchID,
    });
  };

  const InsertMerchantOnBoard = async (BranchID, TillBranchID) => {
    await MerchantPortalClient.post(`/v1/Branch/InsertMerchantOnBoard`, {
      SessionID: sessionStorage.getItem("SessionID"),
      BranchID: BranchID,
      TillBranchID: TillBranchID,
    });
  };

  return {
    UpdateBranchVisibility,
    AddBranch,
    EditBranch,
    DeleteBranch,
    GetBranchDetails,
    GetBranchTills,
    GetBranchTills2,
    branchTills,
    remainingTills,
    setRemainingTills,
    branchDetails,
    GenerateBranchTillOTP,
    AssignTill,
    InsertMerchantOnBoard,
    setBranchTills,
    initialBranchTillsTable,
    setInitialBranchTillsTable,
    initialRemainingBranchTills,
    setInitialRemainingBranchTills,
    branchDetailsLoading
  };
};

export default useBranchAPI;
